export const AVATARS_MOCK = {
    "SERVER_GG_1_DEV_1":{img:'demo101_1.png'},
    "SERVER_GG_1_DEV_2":{img:'safari-fill.svg'},
    "SERVER_GG_1_DEV_3":{img:'demo103_1.png'},
    "SERVER_GG_2_DEV_1":{img:'vimeo-fill.svg'},
    "SERVER_GG_2_DEV_2":{img:'pix-fill.svg'},
    "LOCAL_GG_1_DEV_1": {img:'twitter-fill.svg'},
    "LOCAL_GG_2_DEV_1":{img:'bluesky-fill.svg'},
    "DEMO_101":{img:'demo101_1.png'},
    "DEMO_103":{img:'demo103_1.png'},
}